import Anytime from "./components/Anytime";

function App() {
  return <Anytime />;
}

export default App;
